/**
 * Custom code for the front end
 */

/**
 * Internal dependencies
 */
import init from './init';

/**
 * Initialize the application when the DOM is ready.
 *
 * @requires init
 */
if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
